import React from 'react';
import PacmanLoader from 'react-spinners/PacmanLoader';
import styled from 'styled-components';

const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingIndicator = () => (
  <Wrapper>
    <PacmanLoader size={50} color="#0070c0" margin="0px" loading={true} />
  </Wrapper>
);

export default LoadingIndicator;
